module.exports = __webpack_public_path__ + "img/2024big24.8c1c2406.png";